import { buildFullFileUrl } from '@/api/moudules/file'
import { isBlob } from '@/utils/url'
import _ from 'lodash'
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'

@Component({
    name: 'ImageEx'
})
export class ImageExImpl extends Vue {
    @Prop({

    }) src: string

    realSrc: any = null

    @Watch('src', { immediate: true })
    onSrcChange(value) {
        if (_.isString(value)) {
            this.realSrc = buildFullFileUrl(value)
        } else if (isBlob(value)) {
            const reader = new FileReader();
            reader.readAsDataURL(value)
            reader.onload = () => {
                this.realSrc = reader.result
            };
        }
    }
}
